"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("@scuf/common");

var _NotificationHeaderModal = _interopRequireDefault(require("./NotificationHeaderModal"));

var _ApplicationContext = require("./ApplicationContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var UpdatePasswordModal = /*#__PURE__*/function (_Component) {
  _inherits(UpdatePasswordModal, _Component);

  var _super = _createSuper(UpdatePasswordModal);

  function UpdatePasswordModal(props) {
    var _this;

    _classCallCheck(this, UpdatePasswordModal);

    _this = _super.call(this, props);
    _this.state = {
      loading: false,
      form: {
        userName: null,
        password: null,
        newPassword: null,
        newPasswordConfirm: null
      }
    };
    return _this;
  }

  _createClass(UpdatePasswordModal, [{
    key: "clear",
    value: function clear() {
      var _this$context = this.context,
          setNotificationModal = _this$context.setNotificationModal,
          setNotification = _this$context.setNotification;
      var close = this.props.close;
      var form = {
        userName: null,
        password: null,
        newPassword: null,
        newPasswordConfirm: null
      };
      this.setState({
        form: form
      });
      setNotificationModal(null, null);
      setNotification(null);
      close();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          open = _this$props.open,
          close = _this$props.close;
      var _this$state = this.state,
          loading = _this$state.loading,
          form = _this$state.form;
      var _this$context2 = this.context,
          notificationModal = _this$context2.notificationModal,
          updatePassword = _this$context2.updatePassword,
          setNotification = _this$context2.setNotification,
          handleModalError = _this$context2.handleModalError,
          logout = _this$context2.logout,
          user = _this$context2.user;
      return /*#__PURE__*/_react["default"].createElement(_common.Modal, {
        onClose: function onClose() {
          return _this2.clear();
        },
        open: open,
        closeOnDimmerClick: false,
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement(_common.Modal.Content, null, notificationModal.hasNotification ? /*#__PURE__*/_react["default"].createElement(_NotificationHeaderModal["default"], null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), /*#__PURE__*/_react["default"].createElement(_common.Grid, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "Update Password"))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, /*#__PURE__*/_react["default"].createElement(_common.Loader, {
        loading: loading,
        overlayOpacity: 0.2,
        overlayColor: "#B2AFAF"
      }))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 10
      }, /*#__PURE__*/_react["default"].createElement(_common.Input, {
        fluid: true,
        error: null,
        type: "password",
        label: "Current Password",
        maxLength: "30",
        placeholder: "Password",
        indicator: "required",
        onChange: function onChange(password) {
          return _this2.setState(function (prevState) {
            return {
              form: _objectSpread(_objectSpread({}, prevState.form), {}, {
                password: password
              })
            };
          });
        }
      }))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, /*#__PURE__*/_react["default"].createElement(_common.Grid, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, /*#__PURE__*/_react["default"].createElement(_common.InputLabel, {
        label: "New Password",
        indicator: "required"
      }))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 10
      }, /*#__PURE__*/_react["default"].createElement(_common.Input, {
        fluid: true,
        error: null,
        type: "password",
        maxLength: "30",
        placeholder: "Password",
        onChange: function onChange(newPassword) {
          return _this2.setState(function (prevState) {
            return {
              form: _objectSpread(_objectSpread({}, prevState.form), {}, {
                newPassword: newPassword
              })
            };
          });
        }
      })), /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 2
      }, /*#__PURE__*/_react["default"].createElement(_common.Tooltip, {
        content: "Length should be in between 8 to 30 characters, Minimum 1 character should be uppercase, Minimum 1 character should be number, Minimum 1 character should be special, No sequential 3 numbers like '123' or '234'.",
        element: /*#__PURE__*/_react["default"].createElement(_common.Icon, {
          name: "badge-info",
          root: "common"
        }),
        position: "right",
        event: "hover",
        hoverable: true
      })))))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, /*#__PURE__*/_react["default"].createElement(_common.Grid, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 10
      }, /*#__PURE__*/_react["default"].createElement(_common.InputLabel, {
        label: "Confirm Password",
        indicator: "required"
      }))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 10
      }, /*#__PURE__*/_react["default"].createElement(_common.Input, {
        fluid: true,
        error: null,
        type: "password",
        maxLength: "30",
        placeholder: "Confirm Password",
        onChange: function onChange(newPasswordConfirm) {
          return _this2.setState(function (prevState) {
            return {
              form: _objectSpread(_objectSpread({}, prevState.form), {}, {
                newPasswordConfirm: newPasswordConfirm
              })
            };
          });
        }
      })))))))), /*#__PURE__*/_react["default"].createElement(_common.Modal.Footer, null, /*#__PURE__*/_react["default"].createElement(_common.Button, {
        type: "secondary",
        size: "small",
        content: "Cancel",
        onClick: function onClick() {
          _this2.clear();
        }
      }), /*#__PURE__*/_react["default"].createElement(_common.Button, {
        type: "primary",
        content: "Submit",
        size: "small",
        onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var formToSubmit, response;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  formToSubmit = form;
                  formToSubmit.userName = user.email;

                  if (!(formToSubmit.newPassword === formToSubmit.newPasswordConfirm)) {
                    _context.next = 11;
                    break;
                  }

                  _this2.setState({
                    loading: true
                  });

                  _context.next = 6;
                  return updatePassword(formToSubmit);

                case 6:
                  response = _context.sent;

                  _this2.setState({
                    loading: false
                  });

                  if (!(response instanceof Error)) {
                    close();
                    setNotification("Please login with new password", 'success', true);
                    logout();
                  }

                  _context.next = 12;
                  break;

                case 11:
                  handleModalError('Passwords do not match.');

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      })));
    }
  }]);

  return UpdatePasswordModal;
}(_react.Component);

UpdatePasswordModal.propTypes = {
  open: _propTypes["default"].bool.isRequired,
  close: _propTypes["default"].func.isRequired
};
UpdatePasswordModal.contextType = _ApplicationContext.AppContext;
var _default = UpdatePasswordModal;
exports["default"] = _default;